// Convite para instalar a versão web no celular (AC-251): "Instalar" no Android, o caminho do
// menu Compartilhar no iPhone. Fechar vale para sempre neste navegador; instalado, não aparece.
import { useState, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { browserStorage } from '../platform/adAttribution';
import { dismissInstall, installDismissed, installMode, onInstallChange, promptInstall } from '../platform/pwa';
import { Icon } from './Icon';

const noMode = () => null;

export function InstallAppBanner() {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => installDismissed(browserStorage()));
  const mode = useSyncExternalStore(onInstallChange, () => installMode(), noMode);
  if (dismissed || !mode) return null;
  const close = () => {
    dismissInstall(browserStorage());
    setDismissed(true);
  };
  return (
    <div className="banner banner--install" role="region" aria-label={t('install.label')} data-testid="install-banner">
      <Icon name="monitor" size={15} />
      <span>{mode === 'ios' ? t('install.ios') : t('install.text')}</span>
      {mode === 'prompt' && (
        <button type="button" className="btn btn--small banner__action" onClick={() => void promptInstall().then((ok) => ok && close())}>
          {t('install.button')}
        </button>
      )}
      <button type="button" className="icon-btn" aria-label={t('common.close')} onClick={close}>
        <Icon name="x" size={14} />
      </button>
    </div>
  );
}
